module.exports = __webpack_public_path__ + "img/sld_spd.ade8ea7c.svg";